const purchaseOrderConverter = async (batchId) => {
  // try {
  //   const response = await axios.get(`/api/extensive-prod-creation/getCreatedProd/${batchId}`);
  //   const responseObj = response.data;
  //   const poData = responseObj.productData;

  //   const csvData = poData.map((data) => ({
  //     "Vendor SKU": data.sku,
  //     "Quantity": "12",
  //     "Unit Cost": 1,
  //     "Discount": "",
  //     "Tax%": "",
  //     "Packaging": "",
  //   }));

  //   const timeStamp = new Date();
  //   const formattedDate = `${timeStamp.getMonth() + 1}-${timeStamp.getDate()}-${timeStamp.getFullYear()}`;

  //   const worksheet = XLSX.utils.json_to_sheet(csvData);
  //   const csvOutput = XLSX.utils.sheet_to_csv(worksheet);

  //   const csvBlob = new Blob([csvOutput], { type: "text/csv;charset=utf-8" });

  //   saveAs(csvBlob, `vendor-sku-converter_${batchId}_${formattedDate}.csv`);

  //   console.log("CSV file generated successfully.");
  // } catch (error) {
  //   console.error("Error generating CSV file:", error);
  // }
};

export default purchaseOrderConverter;